import * as moment from "moment";

/**
 * Setzt die Standardeinstellungen für die @see https://momentjs.com/ Library.
 */
export function initMoment(): void
{
    moment.updateLocale("de", {
        monthsShort: ["Jan", "Feb", "Mrz", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]
    });
}